import { useIntersection } from '@agilelab/plugin-wb-platform';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import {
  CSSProperties,
  Dispatch,
  RefObject,
  SetStateAction,
  useEffect,
  useRef,
} from 'react';

type VisibilityCheckerProps = {
  className?: string;
  style?: CSSProperties;
  id: string;
  parentRef: RefObject<HTMLElement>;
  setVisibleIds: Dispatch<SetStateAction<string[]>>;
};

const useStyles = makeStyles(
  () => ({
    root: {
      visibility: 'hidden',
      width: '5px',
      height: '5px',
    },
  }),
  { name: 'VisibilityChecker' },
);

const THRESHOLD = [0.1, 0.3, 0.5, 0.7, 1];

export const VisibilityChecker = ({
  className,
  style,
  id,
  parentRef,
  setVisibleIds,
}: VisibilityCheckerProps) => {
  const classes = useStyles();

  const visibilityCheckerRef = useRef<HTMLDivElement>(null);

  const intersection = useIntersection(visibilityCheckerRef, {
    root: parentRef.current,
    threshold: THRESHOLD,
  });

  useEffect(() => {
    if (!intersection) return;

    // wether the visibility checker is on screen
    const visible = intersection.isIntersecting;

    setVisibleIds(old => {
      // wether this id is already in the visible ids
      const isInOld = old.some(o => o === id);

      // update the visible ids array with this id if visible, without if not visible
      if (visible) return isInOld ? old : [...old, id];

      return isInOld ? old.filter(b => b !== id) : old;
    });
  }, [intersection, id, setVisibleIds]);

  return (
    <div
      ref={visibilityCheckerRef}
      className={clsx(classes.root, className)}
      style={style}
    />
  );
};
